import { render, staticRenderFns } from "./WsReadTab.vue?vue&type=template&id=06a05bd8&"
import script from "./WsReadTab.vue?vue&type=script&lang=js&"
export * from "./WsReadTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports